import PropTypes from "prop-types";
import { Alert as MuiAlert } from "@mui/material";

import "./Alert.scss";

const Alert = ({ type, content, variant, icon, className }) => {
  return (
    <div className="alert-container">
      <MuiAlert
        variant={variant}
        severity={type}
        icon={icon || false}
        className={`${className}`}>
        {content}
      </MuiAlert>
    </div>
  );
};

export default Alert;

Alert.propTypes = {
  type: PropTypes.oneOf(["error", "info", "success", "warning"])
    .isRequired,
  content: PropTypes.oneOfType([PropTypes.string, PropTypes.element])
    .isRequired,
  variant: PropTypes.string,
  icon: PropTypes.element,
  className: PropTypes.string
};

Alert.defaultProps = {
  variant: "outlined"
};
